// components/AccountLayout.jsx
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "./AccountLayout.css";

const AccountLayout = () => {
  const location = useLocation();
  
  return (
    <div className="account-wrapper">
      <div className="account-sidebar">
        <h2 className="sidebar-title">My Account</h2>

        <ul className="sidebar-menu">
          <li className={location.pathname.includes("/account/profile") ? "active" : ""}>
            <Link to="/account/profile">Profile</Link>
          </li>
          <li className={location.pathname.includes("/account/orders") ? "active" : ""}>
            <Link to="/account/orders">Orders </Link>
          </li>
          {/* <li className={location.pathname.includes("/account/wishlist") ? "active" : ""}>
            <Link to="/account/wishlist">Wishlist</Link>
          </li> */}
          {/* <li className={location.pathname.includes("/account/currency") ? "active" : ""}>
            <Link to="/account/currency">Currency</Link>
          </li> */}
        </ul>
      </div>
      <div className="account-content">
        <Outlet /> 
      </div>
    </div>
  );
};

export default AccountLayout;